// `?words` at the start of the text or after whitespace, up to the caret: a non-space first
// character, then at most four more words. A question mark ending a sentence ("ok?") never matches.
const TOKEN = /(^|\s)\?(\S{1,30}(?: \S{1,30}){0,4})$/;

/** Minimum characters after `?` before the inbox searches the help centre. */
export const MIN_ARTICLE_QUERY = 2;

/** The words typed after `?` before the caret, or null when the caret is not in an article token. */
export function articleQuery(text: string, caret: number): string | null {
  const match = TOKEN.exec(text.slice(0, caret));
  return match ? (match[2] ?? '') : null;
}

/** Replaces the `?words` token before the caret with `insert`; returns the new text and caret. */
export function replaceArticleQuery(
  text: string,
  caret: number,
  insert: string,
): { text: string; caret: number } {
  const match = TOKEN.exec(text.slice(0, caret));
  const start = match ? match.index + (match[1]?.length ?? 0) : caret;
  return { text: text.slice(0, start) + insert + text.slice(caret), caret: start + insert.length };
}

/** A markdown link the staff markdown allowlist accepts; brackets in the title are dropped. */
export function articleLink(article: { title: string; url: string }): string {
  return `[${article.title.replace(/[[\]]/g, '')}](${article.url})`;
}
